<template>
    <div>
        <h3>{{ $t("settings.channels.Authentication") }}</h3>
        <p>
            {{ $t("settings.channels.facebook.explainer") }}
        </p>
        <b-input-group v-if="changingPage">
            <b-spinner variant="primary" small class="mr-1"></b-spinner>
            <label>
                {{ $t("settings.channels.facebook.updating-page") }}
            </label>
        </b-input-group>
        <br />

        <div v-if="connected">
            <b-form-group
                id="fieldset-facebook-page"
                label-cols-sm="4"
                label-cols-lg="3"
                content-cols-sm
                content-cols-lg="7"
                label-for="facebook-page"
                :label="$t('settings.channels.facebook.page.label')"
                :description="$t('settings.channels.facebook.page.description')"
            >
                <b-form-select
                    id="facebook-page"
                    :value="channelData.identity"
                    name="facebook-page"
                    :options="pages"
                    @input="localUpdateConnection($event)"
                />
            </b-form-group>
        </div>

        <v-facebook-login
            id="facebook-connection-button"
            name="facebook-connection-button"
            :app-id="facebookAppId"
            :login-options="{
                scope: 'public_profile,email,pages_show_list,pages_manage_metadata,pages_messaging,pages_read_engagement,business_management',
            }"
            loader-class="facebook-loader"
            @login="localFacebookLogin"
            @logout="facebookLogout"
            @click.native.prevent=""
            @sdk-init="sdkInit"
        >
            <div slot="login">{{ $t("settings.channels.facebook.login") }}</div>
            <div slot="logout">
                {{ $t("settings.channels.facebook.logout") }}
            </div>
        </v-facebook-login>
        <hr />
    </div>
</template>

<script>
import VFacebookLogin from "vue-facebook-login-component";
import useFacebook from "../../useFacebook";
import { useToast } from "vue-toastification/composition";
import i18n from "@/libs/i18n";
import { BButton, BCard, BFormGroup, BFormInput, BFormSelect, BInputGroup, BSpinner } from "bootstrap-vue";

export default {
    components: {
        BCard,
        BButton,
        BFormGroup,
        BSpinner,
        BInputGroup,
        BFormInput,
        BFormSelect,
        VFacebookLogin,
    },
    props: {
        channelData: {
            type: Object,
            required: true,
        },
    },
    setup(props) {
        const toast = useToast();

        const {
            FB,
            sdkInit,
            setupFacebook,
            checkFacebookToken,
            facebookLogin,
            facebookLogout,
            updateConnection,
            pageNumber,
            defaultPage,
            selectedPage,
            pages,
            originalPages,
            account,
            connected,
            facebookAppId,
            changingPage,
            disconnecting,
        } = useFacebook(props.channelData);

        const localFacebookLogin = (response) => {
            facebookLogin(response)
                .then(() => toast.success(i18n.t("settings.channels.facebook.success-login")))
                .catch(() => toast.error(i18n.t("settings.channels.facebook.error-login")));
        };

        const localUpdateConnection = (newIdentity) => {
            updateConnection(newIdentity)
                .then(() =>
                    toast.success(
                        disconnecting.value
                            ? i18n.t("settings.channels.facebook.success-disconnecting")
                            : i18n.t("settings.channels.facebook.success-connecting")
                    )
                )
                .catch(() =>
                    toast.success(
                        disconnecting.value
                            ? i18n.t("settings.channels.facebook.error-disconnecting")
                            : i18n.t("settings.channels.facebook.error-connecting")
                    )
                );
        };

        return {
            FB,
            sdkInit,
            setupFacebook,
            checkFacebookToken,
            localFacebookLogin,
            facebookLogout,
            localUpdateConnection,
            pageNumber,
            defaultPage,
            selectedPage,
            pages,
            originalPages,
            account,
            connected,
            facebookAppId,
            changingPage,
        };
    },
};
</script>
